import React from "react";

import { ReactComponent as OpenIcon } from "src/images/open-new-card-blue.svg";
import { Button } from "../Button/Button";
import { ReactComponent as UploadedFileIcon } from "src/images/file-green-check.svg";
import { TooltipedEllipsis } from "../TooltipedEllipsis/TooltipedEllipsis";

import "./FilePreview.scss";

interface FilePreviewProps {
  fileName?: string;
  onClick: () => void;
  fileNameMaxWidth?: number;
}

export default function FilePreview({
  fileName,
  fileNameMaxWidth = 200,
  onClick,
}: FilePreviewProps) {
  return (
    <div className="file-preview">
      <div className="file-preview__file-name-container">
        <UploadedFileIcon />
        {fileName && (
          <Button
            onClick={onClick}
            variant="transparent"
            className="file-preview__file-name"
          >
            <TooltipedEllipsis
              content={fileName}
              maxWidth={fileNameMaxWidth}
              className="text-body-medium"
            />
          </Button>
        )}
      </div>
      <Button
        onClick={onClick}
        variant="white"
        size="square"
        className="file-preview__button"
      >
        <OpenIcon />
      </Button>
    </div>
  );
}
